// crewbit-admin/src/hooks/useAssignWalkIn.ts
//
// Schedule Module Phase C C5A — paired hook for `assign_walk_in` RPC
// (Migration 317 — §Schedule.WalkInQueueSubstrateSplit).
// Mirror of crewbit-mobile/hooks/useAssignWalkIn.ts; bodies byte-identical
// modulo import paths (per feedback_admin_pair_must_match_mobile_body.md).

import { useCallback } from 'react';
import { callScheduleRpc, type ScheduleRpcResult } from '../lib/scheduleRpc';
import type { ConflictDetail } from '../lib/errorMap';

export interface AssignWalkInInput {
  walkInId: string;
  /** public.users.id of the operator receiving the walk-in. */
  operatorId: string;
  /** YYYY-MM-DD (live bookings.date column type). */
  startDate: string;
  /** HH:MM:SS (live bookings.start_time column type). */
  startTime: string;
  /** Pass true to bypass CONFLICT_DETECTED on retry. */
  force?: boolean;
}

export type AssignWalkInResult = ScheduleRpcResult<{
  success: true;
  walk_in_id: string;
  schedule_entry_id: string;
  forced: boolean;
  conflicts?: ConflictDetail[];
}>;

export function useAssignWalkIn() {
  return useCallback(
    async (input: AssignWalkInInput): Promise<AssignWalkInResult> => {
      return callScheduleRpc<{
        success: true;
        walk_in_id: string;
        schedule_entry_id: string;
        forced: boolean;
        conflicts?: ConflictDetail[];
      }>('assign_walk_in', {
        p_walk_in_id: input.walkInId,
        p_operator_id: input.operatorId,
        p_start_date: input.startDate,
        p_start_time: input.startTime,
        p_force: input.force ?? false,
      });
    },
    [],
  );
}
